export default {
  // 2-7 教室/課程/課表管理
  classroom: [],
  classroom_list: [],
  all_course: [],
  all_courselist: [],
  all_classroom: [],

  vendor_list: [],
  course: [],
  course_list: [],
  lecture: [],
  lecture_list: [],

  // 2-10 異動申請審核
  cardId: [],
  cardId_list: [],

  // 2-11 黑名單
  blacklist: [],
  blacklist_list: [],
};
